module.exports = __webpack_public_path__ + "img/tracks.7cb176a1.svg";